import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { IndianCurrency } from 'src/app/pipes/indian-currency.pipe';
import { CampaignType } from './campaign-type';
import { CleanHtmlPipe } from './clean-html.pipe';
import { Time24to12Pipe } from './time24to12.pipe';



@NgModule({
  declarations: [IndianCurrency, CleanHtmlPipe, Time24to12Pipe, CampaignType],
  imports: [
    CommonModule,
    
  ],
  exports: [IndianCurrency, CleanHtmlPipe, Time24to12Pipe, CampaignType]
})
export class PipesModule {
}
